import { axios, getConfigs, IRequestConfig } from './api'
import {
  CreateMssRequestDto,
  MssProviderEmailDto,
  MssRequestDto,
  UpdateMssRequestDto,
} from './dtos'
import { PaginatedDto } from './extendedType'
import { MssFilters, MssRequestFilters } from '@state/reducers/mssReducer'

export class MssService {
  private static readonly endpoint = 'mss'

  static getEmails(
    query: MssFilters,
  ): Promise<PaginatedDto<MssProviderEmailDto>> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        this.endpoint,
        {},
      )
      configs.params = query
      axios(configs, resolve, reject)
    })
  }

  static getAddressesByRpps(rpps: string): Promise<string[]> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        `${this.endpoint}/addresses/${rpps}`,
        {},
      )
      axios(configs, resolve, reject)
    })
  }

  static getRequests(
    query: MssRequestFilters,
  ): Promise<PaginatedDto<MssRequestDto>> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        `${this.endpoint}/requests`,
        {},
      )
      configs.params = query
      axios(configs, resolve, reject)
    })
  }

  static declineEmail(doctorId: number, messageId: string): Promise<void> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = getConfigs(
        'post',
        'application/json',
        `${this.endpoint}/decline/${doctorId}/${messageId}`,
        {},
      )
      axios(configs, resolve, reject)
    })
  }

  static createRequest(
    doctorId: number,
    messageId: string,
    dto: CreateMssRequestDto,
  ): Promise<MssRequestDto> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = getConfigs(
        'post',
        'application/json',
        `${this.endpoint}/request/${doctorId}/${messageId}`,
        {},
      )
      configs.data = dto
      axios(configs, resolve, reject)
    })
  }

  static updateRequest(
    id: number,
    dto: UpdateMssRequestDto,
  ): Promise<MssRequestDto> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = getConfigs(
        'patch',
        'application/json',
        `${this.endpoint}/request/${id}`,
        {},
      )
      configs.data = dto
      axios(configs, resolve, reject)
    })
  }
}
